<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-modal-print
                                ref="print"
                                @close-method="(file_name = null), $refs.print.close()"
                                :file-name="file_name"
                                :no-button="true"
                            ></bc-modal-print>
                            <v-menu left content-class="no-stripe" v-if="selected_invoices.length > 0">
                                <template slot="activator">
                                    <v-btn icon>
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-tile
                                        v-for="item in printOptions"
                                        :key="item.title"
                                        @click="dev_mode ? showPrinter(item.type) : printLabel(item.type)"
                                    >
                                        <v-list-tile-title>
                                            {{ $t(`lang.${item.title}`) }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                    <template v-if="hasPerm('invoices.update')">
                                        <v-divider class="ml-3 my-0"></v-divider>
                                        <v-list-tile v-for="item in invoice_status_options" :key="item.option_id" @click="markInvoices(item)">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-menu>
                            <bc-btn-refresh @invoke-method="dbGetInvoices()" permanent></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams" @open="getArrayData()">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.company_id"
                                            :label="$t('lang.company_id')"
                                            :items="customer_options"
                                            item-value="company_id"
                                            item-text="company"
                                            prepend-icon="business"
                                            single-line
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                </v-list>
                            </bc-search-menu>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table
                        v-model="selected_invoices"
                        :headers="headers"
                        :items="invoices"
                        item-key="invoice_id"
                        :no-data-text="$t('lang.no_results_matching')"
                        hide-actions
                        select-all
                    >
                        <template slot="items" slot-scope="props">
                            <tr :active="props.selected">
                                <td>
                                    <v-checkbox @click.stop="props.selected = !props.selected" :input-value="props.selected" primary hide-details></v-checkbox>
                                </td>
                                <td class="clickable" @mouseup.left="showInvoice(props.item)">{{ props.item.invoice_id }}</td>
                                <td class="clickable" @mouseup.left="showInvoice(props.item)">{{ props.item.company }}</td>
                                <td class="clickable" @mouseup.left="showInvoice(props.item)">{{ props.item.date_due }}</td>
                                <td class="clickable" @mouseup.left="showInvoice(props.item)">{{ props.item.invoice_total || "---" }}</td>
                                <td class="clickable text-center" @mouseup.left="showInvoice(props.item)">
                                    <v-chip disabled round :color="props.item.status.class">
                                        <span class="white--text">{{ props.item.status && props.item.status.option ? props.item.status.option : "---" }}</span>
                                    </v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="invoices"></bc-pagination>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                { text: this.$t("lang.invoice_number_short"), sortable: false, width: "15%" },
                { text: this.$t("lang.company_id"), sortable: false, width: "25%" },
                { text: this.$t("lang.date_due"), sortable: false, width: "25%" },
                { text: this.$t("lang.total"), sortable: false, width: "10%" },
                { text: this.$t("lang.status"), sortable: false, width: "15%", align: "center" },
            ],
            printOptions: [{ title: "print_invoice", type: "invoice" }, { title: "print_all", type: "all" }],
            customers: null,
            selected_invoices: [],
            file_name: null,
            invoice: {
                company_id: "",
                sold_to_address_id: "",
                ship_to_address_id: "",
                bol_id: "",
                shipping_method_id: "",
                date_shipped: "",
                date_due: "",
                carrier_id: "",
                payment_term_id: "",
                invoice_sent: "",
            },
            filter: {
                search: "",
                company_id: "",
                page_size: 0,
                page_num: 0,
            },
            dbGetInvoices: _.debounce(this.getInvoices, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch("fetchSetting", {
            url: "options?slug=invoice_status&sort_by=2",
            method: "get",
            stateProperty: "invoice_status_options",
            dataProperty: "options",
            commit: true,
        });

        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchInvoice", {
                url: "invoices",
                method: "get",
                stateProperty: "invoices",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.invoices) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchInvoice", {
                url: "invoices",
                method: "get",
                stateProperty: "invoices",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.invoices) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_invoice: (state) => state.validation.rules_invoice,
            default_filter: (state) => state.invoices.invoices_filter,
            page: (state) => state.invoices.page,
            invoices: (state) => state.invoices.invoices,
            packing_lists: (state) => state.packing_lists.packing_lists,
            parts: (state) => state.parts.parts,
            invoice_status_options: (state) => state.settings.invoice_status_options,
            customer_options: (state) => state.customers.customer_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchCustomers"]),
        showPrinter(type) {
            // this.startLoader();
            this.$refs.print.openDialog();

            let url = type == "all" ? "print_all" : "print";
            this.$store
                .dispatch("fetchInvoice", {
                    url: `invoices/${url}`,
                    method: "get",
                    body: {
                        invoice_id: this.selected_invoices.map((w) => w.invoice_id),
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.invoice) {
                        this.file_name = data.invoice.file_name;
                    } else {
                        this.file_name = "";
                        this.$refs.print.close();
                        this.createAlert();
                    }
                });
        },
        printLabel(type) {
            this.$store.commit("toggleGlobalSnackbar", true);
            let url = type == "all" ? "print_all" : "print";
            this.$store
                .dispatch("fetchInvoice", {
                    url: `invoices/${url}`,
                    method: "get",
                    body: {
                        invoice_id: this.selected_invoices.map((w) => w.invoice_id),
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.invoice) {
                        this.$refs.print.printReport(data.invoice.file_name);
                    } else {
                        this.createAlert();
                    }
                    this.$store.commit("toggleGlobalSnackbar", false);
                });
        },
        getArrayData() {
            if (this.customers == null) this.getCustomers();
        },
        getInvoices() {
            this.startLoader();
            this.$store
                .dispatch("fetchInvoice", {
                    url: "invoices",
                    method: "get",
                    stateProperty: "invoices",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        getCustomers() {
            this.fetchCustomers({ body: { options: 1 } });
        },
        modifyInvoice(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("invoice")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchInvoice", {
                                pk: "invoice_id",
                                id: id,
                                url: `invoices/${id ? id : ""}`,
                                method: method,
                                stateProperty: "invoices",
                                mutate: true,
                                body: this.invoice,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeInvoiceDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        markInvoices(status) {
            if (status && this.selected_invoices.length > 0) {
                this.startLoader();
                this.$store
                    .dispatch("fetchInvoice", {
                        pk: "invoice_id",
                        url: "invoices/status",
                        method: "patch",
                        stateProperty: "invoices",
                        mutate: true,
                        body: {
                            invoices: this.selected_invoices.map((invoice) => ({ invoice_id: invoice.invoice_id, status_id: status.option_id })),
                        },
                    })
                    .then((data) => {
                        if (data && data.code == "200") {
                            //console.log(data);
                        }
                        this.finishLoader();
                    });
            }
        },
        showInvoice(item = null) {
            if (item) {
                this.startLoader();
                this.$router.push({ name: "invoice", params: { id: item.invoice_id } });
            }
        },
    },
};
</script>
